import { FormErrors } from 'redux-form';

export default (values: any) => {
  const errors: FormErrors<any> = {};

  if (!values.cmrCard) {
    errors.cmrCard = 'Debe ingresar el número de tarjeta';
  } else if (values.cmrCard.trim().length < 4) {
    errors.cmrCard = 'Debe ingresar 4 dígitos';
  }

  if (!values.companyCheck) {
    errors.companyCheck = 'Campo obligatorio';
  }

  if (!values.consentCheck) {
    errors.consentCheck = 'Campo obligatorio';
  }

  if (!values.legalTermsCheck) {
    errors.legalTermsCheck = 'Campo obligatorio';
  }

  return errors;
};
